export default function leadForm() {
    const form = document.querySelector(".fh-lead-form");
    if (!form) return;

    const button = form.querySelector(".fh-flyer-submit");
    const message = form.querySelector(".fh-lead-message");
    const webhookUrl = form.dataset.webhookUrl;

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        button.disabled = true;
        button.style.opacity = "0.7";
        message.textContent = "";

        const payload = Object.fromEntries(new FormData(form).entries());

        try {
            if (webhookUrl) {
                await fetch(webhookUrl, {
                    method: "POST",
                    mode: "no-cors",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
            }

            button.classList.add("fh-flyer-success");
            message.textContent =
                "Danke für deine Nachricht! Wir melden uns zeitnah bei dir.";
            form.reset();

            setTimeout(() => {
                button.classList.remove("fh-flyer-success");
                button.disabled = false;
                button.style.opacity = "1";
            }, 2200);
        } catch (err) {
            message.textContent =
                "Da ist etwas schiefgelaufen. Bitte versuche es erneut oder ruf uns direkt an.";
            button.disabled = false;
            button.style.opacity = "1";
        }
    });
}
